import { setLoading } from "../../feature/authSlice"
import { apiConstants } from "../apiConstant"
import { serviceCall } from "../serviceCall"

export const getPermissionHeirarchyApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCall({
      url: apiConstants.AUTH.GET_PERMISSION_HEIRARCHY,
      method: 'post',
      data: data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
